const reportWebVitals = onPerfEntry => {
  // Dev-only: keep the dynamic import inside a NODE_ENV === "development" block
  // so webpack statically eliminates it from production builds (no chunk emitted,
  // nothing logs or ships in prod).
  if (process.env.NODE_ENV === "development") {
    // Use the provided callback, or fall back to logging each metric to the console.
    const report =
      onPerfEntry instanceof Function
        ? onPerfEntry
        : metric => console.log(`[web-vitals] ${metric.name}: ${metric.value}`, metric);

    import("web-vitals").then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      onCLS(report);
      onINP(report);
      onLCP(report);
      onFCP(report);
      onTTFB(report);
    });
  }
};

export default reportWebVitals;
